export default class Tooltip {
    constructor(container) {
        this.$container = container;
        this.id = this.$container.attr('id');
        this.tooltipInfo = {};
        this.noStorage = this.$container.data('tooltip-nostorage');

        let closeSelector = this.$container.data('tooltip-close-selector');

        this.$container.find('[data-tooltip-close]').on('click', () => this.hideTooltip());
        $(closeSelector).on('click', () => this.hideTooltip());
    }

    showTooltip () {
        this.$container.removeClass('hidden');
    }

    hideTooltip () {
        this.$container.addClass('hidden');

        if(!this.noStorage === true) {
            this.tooltipInfo[this.id] = false;
            localStorage.tooltip = JSON.stringify(this.tooltipInfo);
        }
    }

    init() {
        if(!this.noStorage === true) {
            try {
                if (typeof localStorage.tooltip === 'undefined') {
                    localStorage.tooltip = '{}';
                }

                this.tooltipInfo = JSON.parse(localStorage.tooltip);

                if (typeof this.tooltipInfo[this.id] === 'undefined') {
                    this.tooltipInfo[this.id] = true;
                }

                if (this.tooltipInfo[this.id]) {
                    this.showTooltip();
                } else {
                    this.hideTooltip();
                }
            } catch (e) {
                this.hideTooltip();
            }
        }
    }
}
